import { Component, Input } from '@angular/core';
import { IndustrySurchargeResponse } from '../../../../api';
import { BaseIndustrySurchargesDateType } from '../../../shared/enums/base-industry-surcharges.enum';

@Component({
  selector: 'base-industry-surcharges',
  templateUrl: './base-industry-surcharges.component.html',
})
export class BaseIndustrySurchargesComponent {
  @Input() surcharges: IndustrySurchargeResponse | null | undefined;
  @Input() showCategoryAndMethod = false;
  dateUnitType = BaseIndustrySurchargesDateType;
}
